import { render, staticRenderFns } from "./index.vue?vue&type=template&id=407c8391&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=407c8391&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c8391",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\MyCode\\shop\\waynboot-mobile-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407c8391')) {
      api.createRecord('407c8391', component.options)
    } else {
      api.reload('407c8391', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=407c8391&scoped=true", function () {
      api.rerender('407c8391', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tabbar/index.vue"
export default component.exports